// createChatBody.js — S-B1 pure builder for the new-chat (createChat) POST body.
//
// Threads the client `messageId` through the new-chat path so Sessions::Start can ingest the
// first human turn as a durable TEXT_MESSAGE that dedups the optimistic first bubble (without
// this, the first user bubble renders TWICE — durable echo + optimistic, with no shared key).
//
// Mirrors AgentStudioChat.jsx's existing createChat body shape (READ-ONLY reference, not edited):
//   buildSendBody → { text, model, message_id?, effort? }; createChat strips `text`, sends
//   { prompt: text, ...rest }. So the wire body is { prompt, model, message_id?, effort? }.
// Extracted here as an exported pure fn so it's node-testable; the JSX call site adopts it.

import { buildSendBody } from "./studioShellViewModel.js"

export function buildCreateChatBody({ text, messageId, model, effort, attachments }) {
  // Reuse the canonical send-body builder (handles the effort gate per model AND the Task 5
  // attachments gate — the key is present only when non-empty), then map to the createChat wire
  // contract: `prompt` instead of `text`, plus the client message_id. `attachments` (when the base
  // included it) flows through `...rest` unchanged.
  const base = buildSendBody({ text, message_id: messageId, model, effort, attachments })
  const { text: _t, message_id: _m, ...rest } = base
  return { prompt: text, message_id: messageId, ...rest }
}
